import React from 'react'

function Svg5(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={24}
      height={24}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#5_svg__clip0)">
        <path
          d="M4.093 9.733A5.733 5.733 0 019.826 4h4.348a5.733 5.733 0 015.733 5.733v0a.382.382 0 01-.382.382H4.475a.382.382 0 01-.382-.382v0zM19.907 16.926A3.074 3.074 0 0116.834 20H7.167a3.074 3.074 0 01-3.074-3.074v0c0-.17.138-.307.308-.307H19.6c.17 0 .307.138.307.307v0z"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <rect
          x={3.632}
          y={10.145}
          width={16.737}
          height={3.222}
          rx={1.611}
          stroke="currentColor"
        />
        <rect
          x={3.632}
          y={13.397}
          width={16.737}
          height={3.222}
          rx={1.611}
          stroke="currentColor"
        />
        <path
          d="M14.214 15.807l3.714-2.41H10.5l3.714 2.41z"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6 10.25A5.733 5.733 0 0010.13 12c1.622 0 3.086-.67 4.131-1.75H6z"
          stroke="currentColor"
        />
        <rect
          width={0.5}
          height={1}
          rx={0.25}
          transform="rotate(45 -2.036 13.864)"
          fill="currentColor"
        />
        <rect
          x={6.16}
          y={7.112}
          width={0.5}
          height={1}
          rx={0.25}
          transform="rotate(-15 6.16 7.112)"
          fill="currentColor"
        />
        <rect
          x={14.784}
          y={5.75}
          width={0.5}
          height={1}
          rx={0.25}
          transform="rotate(-30 14.784 5.75)"
          fill="currentColor"
        />
        <rect
          width={0.5}
          height={1}
          rx={0.25}
          transform="rotate(48.326 -1.12 16.899)"
          fill="currentColor"
        />
        <rect
          x={16.966}
          y={7.808}
          width={0.5}
          height={1}
          rx={0.25}
          transform="rotate(-90 16.966 7.808)"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="5_svg__clip0">
          <path fill="#fff" d="M0 0h24v24H0z" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default Svg5
